var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var PLACEHOLDER = '[]';
// TurboTax has 2 test workspaces, so overriding strings for both.
var TURBOTAX_WORKSPACES = ['TurboTax', 'TurboTax (NativeLink Test)'];
var TURBOTAX_OVERRIDES = {
    LOGIN_USING_ACCOUNT: {
        en: "Access your ".concat(PLACEHOLDER, " account"),
        es: "Accede a tu cuenta ".concat(PLACEHOLDER),
    },
    YOUR_ACCOUNT_CONNECTED: {
        en: 'Access granted',
        es: 'Acceso concedido',
    },
    SUCCESS_SUBTITLE: {
        en: "We will now download and pass your previous year's return to TurboTax.",
        es: 'Ahora descargaremos y pasaremos su declaración del año anterior a TurboTax',
    },
    CLOSE: {
        es: 'Continuar',
        en: 'Continue',
    },
};
export var WORKSPACE_SPECIFIC_LOCALIZED_STRINGS = __assign(__assign({}, Object.fromEntries(TURBOTAX_WORKSPACES.map(function (workspace) { return [workspace, TURBOTAX_OVERRIDES]; }))), { Lendly: {
        CLOSE: {
            es: 'Continuar',
            en: 'Continue',
        },
    }, Avibra: {
        BILL_NAVIGATOR_TITLE: {
            en: 'Welcome to Subscription Tracker, powered by Pinwheel',
            es: 'Bienvenido a Subscription Tracker, desarrollado con Pinwheel',
        },
        BILL_NAVIGATOR: {
            en: 'Subscription Tracker',
            es: 'Subscription Tracker',
        },
    }, Plaid: {
        CLOSE: {
            en: 'Review Data',
            es: 'Revisar Datos',
        },
    }, 'American Express': {
        CLOSE: {
            en: 'Return to Amex',
            es: 'Regresar a Amex',
        },
        RETURN_TO_BANKAPP: {
            en: 'Return to Amex',
            es: 'Regresar a Amex',
        },
        EXIT_AND_RETURN_TO_BANKAPP: {
            en: 'Return to Amex',
            es: 'Regresar a Amex',
        },
    }, Square: {
        /**
         * https://pinwheel.atlassian.net/browse/CORE-1783
         * Display "payout" wording instead of "paycheck" for Square workspace
         */
        YOUR_DIRECT_DEPOSIT: {
            es: '¡Tu configuración de depósito directo se ha actualizado!',
            en: 'Your payout settings have been updated!',
        },
        YOUR_CHANGES_SHOULD: {
            es: 'Sus cambios deberían ser efectivos en 1-2 ciclos\u00A0de\u00A0nómina.',
            en: 'Your changes should be effective in 1-2 payout\u00A0cycles.',
        },
        FULL_PAYCHECK: {
            es: 'Pago completo',
            en: 'Full payout',
        },
        PARTIAL_PAYCHECK: {
            es: 'Pago parcial',
            en: 'Partial payout',
        },
        EVERY_PAYCHECK: {
            en: 'Every payout',
            es: 'Cada cheque de pago',
        },
        DIRECT_DEPOSIT_SETTINGS: {
            es: 'Configuración de depósito\u00a0directo',
            en: 'Payout settings',
        },
        PAYROLL: {
            es: 'cuenta',
            en: 'account',
        },
    }, 'Nassau Financial CU': {
        AUTOMATED_DDS_DISABLED_FOR_ACCOUNT: {
            // https://pinwheel.atlassian.net/browse/CORE-1929 - Nassau FCU wanted to change
            // account => payroll account
            en: 'Automated direct deposit switching is disabled for your payroll account',
            es: 'El cambio automático de depósito directo está deshabilitado para su cuenta de nómina',
        },
    }, 'Affinity FCU': {
        // https://pinwheel.atlassian.net/browse/CORE-1926 - Affinity FCU wanted to change
        // bank => Credit Union
        // customer(s) => member(s)
        WIZARD_PAYMENT_METHODS_CHECKBOX_DIRECT_DEPOSIT: {
            en: 'Direct deposit to Credit Union account',
            es: 'Depósito directo a cuenta de cooperativa de crédito',
        },
        ACCOUNT_TO_AN_APP: {
            es: "Cuando usa Pinwheel para conectar un ".concat(PLACEHOLDER, " a una aplicaci\u00F3n, ayudamos a mantener sus datos seguros y privados con protocolos de cifrado de nivel de cooperativa de cr\u00E9dito como el Est\u00E1ndar de cifrado avanzado (AES 256) y Seguridad de la capa de transporte (TLS)."),
            en: "When you use Pinwheel to connect a ".concat(PLACEHOLDER, " to an app, we help keep your data safe and private with Credit Union level encryption protocols like the Advanced Encryption Standard (AES 256) and Transport Layer Security (TLS)."),
        },
    }, Flow: {
        DOCUMENT_UPLOADS_PRIMER: {
            en: "Upload at least 6 weeks of paystubs to verify your income.",
            es: "Sube al menos 6 semanas de talones de pago para verificar tus ingresos.",
        },
    }, EliseAI: {
        DOCUMENT_UPLOADS_PRIMER: {
            en: "Share requested documents with ".concat(PLACEHOLDER, " to help verify your income and employment."),
            es: "Comparte los documentos solicitados con ".concat(PLACEHOLDER, " para ayudar a verificar tus ingresos y empleo."),
        },
    } });
